import { combineReducers } from 'redux';
import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';

function createReducer(additionalReducers = {}) {
  return combineReducers({
    impressions,
    ...additionalReducers,
  });
}

const combinedReducers = createReducer();

export default function rootReducer(state = {}, action) {
  return combinedReducers(state, action);
}
